declare global {
	interface Window {
		grecaptcha?: {
			ready: (cb: () => void) => void;
			execute: (captchaKey: string, opts: { action: 'submit' }) => Promise<string>;
		};
	}
}

export function generateCaptchaToken(): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		if (window.grecaptcha) {
			window.grecaptcha.ready(function () {
				if (import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY !== undefined) {
					window.grecaptcha
						?.execute(import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY, { action: 'submit' })
						.then((captchaToken) => resolve(captchaToken));
				} else {
					reject(new Error('[WARN] Invalid Google Recaptcha site key or invalid origin'));
				}
			});
		} else {
			reject(new Error('[WARN] Google Recaptcha not loaded'));
		}
	});
}
